const pages = [
    {
        path: "/:catchAll(.*)",
        component: () => import("../components/NotFound.vue"),
        meta: {
            requireAuth: false,
        },
    },
];

export default pages;
